export const environment = {
  production: true,
  BUILT_AT: "2026-5-28 11:3:17",
};
